import { serviceRequest } from './service-request';
import type { ConnectionOptionsViewModel } from '@cognitoforms/types/server-types/services/controllers/svc-controllers/integrations/connection-options-view-model';

export function getThumbprint() {
	let id: string | null = null;
	if (typeof (Storage) !== 'undefined') {
		id = localStorage.getItem('c-user');
		if (!id) {
			id = crypto.randomUUID();
			localStorage.setItem('c-user', id);
		}
	}

	return id;
}

export function adminForgotPassword() {
	return serviceRequest('svc/auth/password/forgot-authenticated', { });
}

export function verifyEmailChange(newEmail: string, password: string) {
	return serviceRequest('svc/auth/email/verify-email-change', { newEmail: newEmail, password: password });
}

export function changeEmail(code: string) {
	return serviceRequest('svc/auth/email/change', { code });
}

export function resendInvitation(userId: string) {
	return serviceRequest('svc/organizations/resend-invitation', { userId }, { method: 'POST' });
}

export function getVerificationInfo() {
	return serviceRequest('svc/auth/verify/get-verification-info', null, { method: 'GET' });
}

export function getOauthConnectionOptions (): Promise<ConnectionOptionsViewModel> {
	return serviceRequest('svc/integration/oauth/connection-options', null, { method: 'GET' });
}

export function resendUserVerificationEmail() {
	return serviceRequest('svc/auth/verify/resend-verify-email', null, { method: 'POST' });
}